import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["role", "atomic", "children", "aria-live"];
import React, { forwardRef } from 'react';
import Box from 'components/Box';
var Status = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$role = props.role,
    role = _props$role === void 0 ? 'status' : _props$role,
    atomic = props.atomic,
    children = props.children,
    ariaLive = props['aria-live'],
    otherProps = _objectWithoutProperties(props, _excluded);
  var ariaLiveDefault = role === 'alert' ? 'assertive' : 'polite';
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    role: role,
    "aria-live": ariaLive || ariaLiveDefault,
    "aria-atomic": atomic ? 'true' : props['aria-atomic']
  }, otherProps), children);
});
Status.displayName = 'Status';
export default Status;